<template>
  <div class="page-main">
    <template v-if="!isProd">
      <debug-panel></debug-panel>
    </template>
    <template v-else>
      <page-not-found></page-not-found>
    </template>
  </div>
</template>

<script>
  import DebugPanel from '@/pages/Home/DebugPanel'
  import { isProd } from '@/helpers'
  import PageNotFound from '@/pages/Shared/NotFound'

  export default {
    name: 'PageHomeMain',

    components: { PageNotFound, DebugPanel },

    data () {
      return {
        isProd,
        cpCode: 1,
        builtDate: process.env.BUILT_DATE,
        timer: (new Date()).toTimeString(),
        agent: navigator.userAgent
      }
    },

    created () {
    },

    mounted () {
    }
  }
</script>

<style lang="scss">
  .page-main {
    overflow: hidden;
    background-color: #f7f8fa;
    height: 100vh;
    width: 100%;
    box-sizing: border-box;

    h2 {
      text-align: center;
      padding-bottom: 50px;
    }

    .links {
      > a {
        display: flex;
        margin: 20px;
      }
    }

    .debug-text {
      color: #555;
    }
  }
</style>
